<template>
<div class="dashboard">
    
    <v-container fluid>

      <v-layout row wrap align-center justify-space-between class="mb-3">
        <span><h2 class="display-1 py-3"><strong>{{ formatNiceDate(today) }}</strong><span class="font-weight-light"> Appointments</span></h2></span>
        <span>
          <v-btn @click="$refs.calendar.prev()">
            <v-icon
              dark
              left
            >
              keyboard_arrow_left
            </v-icon>
            Prev
          </v-btn>

          <v-btn @click="$refs.calendar.next()">
            Next
            <v-icon
              right
              dark
            >
              keyboard_arrow_right
            </v-icon>
          </v-btn>

        </span>
      </v-layout>
        
 <v-layout class="mb-5">
     
    <v-flex>
      <v-sheet class="main-sheet">
        <!-- now is normally calculated by itself, but to keep the calendar in this date range to view events -->
        <v-calendar
          ref="calendar"
          :now="today"
          :value="today"
          :weekdays="[1,2,3,4,5]"
          v-model="today"
          color="primary"
          type="week"
          first-interval="9"
          interval-count="10"
        >


          <!-- the events at the top (all-day) -->
          <template v-slot:dayHeadere="{ date }">
            
            <template v-for="app in appointmentsMap[date]">
              <!-- all day events don't have time -->
              
              <div
                v-if="!app.time"
                :key="app.uid"
                class="my-app"
                @click="openAppointment(app)"
                v-html="app.submission.firstName+' '+app.submission.surname"
              ></div>
            </template>
          </template>



          <!-- the events at the bottom (timed) -->
          <template v-slot:dayBody="{ date, timeToY, minutesToPixels }">
            <div v-for="(appGroup, appGroupIndex) in daysAppointments[date]"
                  :key="appGroupIndex"
                  :style="{ top: timeToY(appGroup.time) + 'px', height: minutesToPixels(29) + 'px' }"
                  class="app-group"
              >
              <!-- timed events -->
              <div v-for="(app, appIndex) in sameTimeSlot[date][appGroup.time]"
                  :key="appIndex"
                  class="app-item"
                  @click="openAppointment(app)"
                  v-html="app.submission.firstName+' '+app.submission.surname"
              >
              </div>
              <!-- <div
                v-if="app.time"
                :key="app.uid"
                :style="{ top: timeToY(app.time) + 'px', height: minutesToPixels(30) + 'px' }"
                class="my-app with-time"
                @click="openAppointment(app)"
                v-html="app.submission.firstName+' '+app.submission.surname"
              ></div> -->
            </div>
          </template>
        </v-calendar>
      </v-sheet>
    </v-flex>
  </v-layout>

  
    <!-- SUBMISSIONS TABLE -->
    <!-- <v-data-table
      style="opacity:0.95;"
      :headers="headers"
      :items="appointments"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      class="elevation-2 submissions-data-table"
      :search="search"
    >
   
      <template slot="items" slot-scope="props">
        <tr>
          <td class="text-xs-left" v-for="column in headers" v-bind:key="column.value">
            
            
            {{ getColumnValue(props.item, column.key, column.value) }}
              
          </td>  
        </tr>
      </template>
      

      <template slot="no-data">
        <v-alert :value="true" color="error" icon="warning">
          Sorry, nothing to display here :(
        </v-alert>
      </template>
      
    </v-data-table> -->

    </v-container>

</div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'appointments',
    data() {
        return {
            search: '',
            rowsPerPageItems: [10, 25, 50],
            pagination: {
                descending: true,
                rowsPerPage: 10,
                sortBy: 'date'
            },

            // Table Cols - value = the metadata key in the json, key = the next level object in the json data 
            headers: [
                { text: 'Date', sortable: true, key: null, value: 'date' },
                { text: 'Time', sortable: true, key: null, value: 'time' },
                { text: 'Updated', sortable: true, key: null, value: 'updated' },
                //{ text: 'Rescheduled?', sortable: true, key: null, value: 'rescheduled' },
                
            ],
            today: moment().format('YYYY-MM-DD')
        }
    },
    computed: {
        appointments() {
            return this.$store.getters.appointments
        },
        submissions() {
          return this.$store.getters.submissions
        },
        daysAppointments() {
            const map = {}
            this.appointments.forEach(app => (map[app.date] = map[app.date] || []).push(app))
            
            return map
        },
        sameTimeSlot() {
          const dayApps = {}
          this.appointments.forEach(app => (dayApps[app.date] = dayApps[app.date] || []).push(app))
          //console.log(dayApps)
          
          const sameTS = {}
          for (const date in dayApps) {
            if (dayApps.hasOwnProperty(date)) {
              const appsArray = dayApps[date];
                sameTS[date] = {}
                appsArray.forEach(app => (sameTS[date][app.time] = sameTS[date][app.time] || []).push(app))
                //sameTS[date][app[0].time].push(app)
            }
          }
          //onsole.log(sameTS)
          return sameTS
        }
        /*
        filteredItems() {
            return this.$store.getters.submissions.filter((i) => {
                return !this.selectedStatus || (i.status === this.selectedStatus);
        })*/
    },
    mounted () {
      this.$refs.calendar.scrollToTime('08:00')
    },
    beforeCreate: function(){
        this.$store.dispatch('fetchAppointments')
    },
    methods: {
        openAppointment (appointment) {
            let alertHtml = appointment.submission.firstName + 
                            ' ' + appointment.submission.surname +
                            ' @ ' + appointment.time +
                            '\nMake: ' + appointment.submission.make +
                            '\nModel: ' + appointment.submission.model 
            if( appointment.rescheduled ) {
              alertHtml += '\nRescheduled: YES'
            }
            alert(alertHtml)
        },
        getColumnValue(item, key, value) {
            // Handle data that is one level down in the json data using key
            let db_value = null
            if(key!==null) {
                let node = item[key]
                db_value = node[value]
            } else {
                db_value = item[value] 
            }

            // Convert any data that is in the wrong format for display
            let value_filtered = db_value

            if(value=='date')
                value_filtered = this.convertDate(db_value, false)

            if(value=='updated')
                value_filtered = this.convertDate(db_value, true)
            return value_filtered
        },
        convertDate: function(timestamp, includeTime) {
            if(includeTime)
                return moment(timestamp).format('DD/MM/YYYY ~ HH:mm')
            else  
                return moment(timestamp).format('DD/MM/YYYY')
        },
        formatNiceDate: d => { 
            //let exp = d.split("-");
            //return exp[2]+' '+exp[1]+' '+exp[0];
            //return moment(d).format('dddd, Do MMMM YYYY')
            return moment(d).format('MMMM YYYY')
        },
    }

}





</script>

<style scoped>

.app-group {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
  position: absolute;
  
}

.app-item {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  font-size: 12px;
  padding: 0 3px;
  cursor: pointer;
  margin-bottom: 1px;
  flex: auto;
  margin-left: 2px;
  margin-right: 2px;
}
.my-app {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #1867c0;
    color: #ffffff;
    border: 1px solid #1867c0;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
    left: 4px;
    margin-right: 8px;
    position: relative;

    
  }

  .my-app.with-time {
      position: absolute;
      right: 4px;
      margin-right: 0px;
    }


    .dashboard{
  
  height: 100%;
  background-image: url(../assets/CarWall16.jpg);
  background-size: cover;
   background-color: rgba(30,0,0,0.6);
  background-blend-mode: darken;
}


.main-sheet{
  opacity: 0.95!important;
}
  </style>